module.exports = __webpack_public_path__ + "img/stock.78e8d179.png";